import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconJoy({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17.291 6.014c-.036-.072-.077-.15-.134-.256a7.48 7.48 0 00-1.205-1.59l-5.466 5.46-1.23-1.273L7.68 9.928l2.782 2.872 6.83-6.786z"
        fill="#EF8165"
      />
      <path
        d="M15.908 9.09c.05.298.075.622.075.945 0 2.44-1.423 4.68-3.644 5.7a6.148 6.148 0 01-6.388-.945 6.394 6.394 0 01-1.323-7.817 6.103 6.103 0 016.938-2.887 5.63 5.63 0 011.996 1.02l1.522-1.518c-.599-.473-1.248-.896-1.971-1.195C9.793.974 5.85 2.02 3.555 4.733 1.409 7.322.985 10.93 2.507 13.919a8.466 8.466 0 008.934 4.356c4.492-.822 7.486-5.128 6.663-9.609a6.544 6.544 0 00-.374-1.37L15.908 9.09z"
        fill="#373A3C"
      />
    </svg>
  );
}
export default SvgIconJoy;
